import { IconGiftFilled } from '@tabler/icons-react';
import styled from 'styled-components';

import { BRAND_COLORS } from 'brand-guidelines/colors';
import { ContentContainer } from 'brand-guidelines/Layout-styled-components';

import { TYPOGRAPHY } from 'brand-guidelines/typography';

import { STEP_WRAPPER_MAX_WIDTH } from '../common/styleConstants';
import { BaseHeaderText } from '../common/typographic-styled-components';

export const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
`;

export const Container = styled(ContentContainer)`
  align-items: center;
  justify-content: space-between;
  flex-direction: row;

  max-width: ${STEP_WRAPPER_MAX_WIDTH}px;

  padding: 7px 12px;

  border-radius: 8px;
  gap: 10px;

  background-color: ${BRAND_COLORS.bannerRed};
  color: ${BRAND_COLORS.white};
`;

export const ContentWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const GiftIcon = styled(IconGiftFilled).attrs({
  size: 20,
})`
  flex-shrink: 0;
`;

export const OfferText = styled(BaseHeaderText)`
  font-size: 14px;
  line-height: 24px;
  color: ${BRAND_COLORS.white};
`;

export const SeeHowButton = styled.button`
  background-color: white;
  color: ${BRAND_COLORS.bannerRed};
  border: 1px solid white;
  border-radius: 25px;
  padding: 3px 16px;
  ${TYPOGRAPHY.CIRCULAR.bold}
  font-size: 14px;
  line-height: 20px;
  text-align: center;
  white-space: nowrap;
  cursor: pointer;
  flex-shrink: 0;
`;
